import type {
    AddAsteriskInternalParams,
    AddWebrtcAccountParams,
    GetRedirectNumberResponse,
    Optional,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/asterisk';

// https://srv-pbx-02.chaika.com/api/swagger/index.html
export class AsteriskApi {
    public static async addRedirectNumbers(shortNumber: number, data: AddAsteriskInternalParams): Promise<void> {
        await axios.post(`${BASE_URL}/internal/${shortNumber}`, data);
    }

    public static async addWebrtcAccount(user: AddWebrtcAccountParams): Promise<void> {
        await axios.post(`${BASE_URL}/webrtc`, { users: [user] });
    }

    public static async removeRedirect(shortNumber: number): Promise<void> {
        await axios.delete(`${BASE_URL}/internal/${shortNumber}`);
    }

    public static async get(shortNumber: number): Promise<Optional<string>> {
        let res: Optional<string>;

        try {
            const { data } = await axios.get<GetRedirectNumberResponse>(`${BASE_URL}/internal/${shortNumber}`);
            if (data.phoneNumber !== null) {
                res = data.phoneNumber.toString();
            }
            // eslint-disable-next-line sonarjs/no-ignored-exceptions
        } catch (e: any) {}

        return res;
    }
}
